import { ChangeEvent } from 'react'

interface UploadFieldProps {
  label: string
  files: File[]
  onAdd: (files: File[]) => void
  onRemove: (index: number) => void
}

// Hairline dashed dropzone + new-file thumbnails, in the admin palette.
// Shared by the product New and Edit forms.
export function UploadField({ label, files, onAdd, onRemove }: UploadFieldProps) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) onAdd(Array.from(e.target.files))
  }

  return (
    <div className="sss-admin-field">
      <span className="sss-admin-label">{label}</span>
      <div className="sss-admin-drop">
        <label className="sss-admin-drop__label">
          Upload images
          <input type="file" multiple accept="image/*" onChange={handleChange} className="sr-only" />
        </label>
        <p className="sss-admin-hint">PNG, JPG, GIF up to 10MB</p>
      </div>

      {files.length > 0 && (
        <div className="sss-admin-thumbs">
          {files.map((file, index) => (
            <div key={index} className="sss-admin-thumb">
              <img src={URL.createObjectURL(file)} alt={`Preview ${index + 1}`} />
              <button
                type="button"
                onClick={() => onRemove(index)}
                className="sss-admin-thumb__btn"
                aria-label="Remove image"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
